<template>
  <div class="mb-6">
    <div class="d-flex flex-row just-between align-center mb-5">
      <div class="flex-column">
        <div class="med sac__font-18">
          Zone:
          {{ item.zone }}
        </div>
      </div>
      <div class="connection-card flex-row pl-3 pr-3">
        <p v-if="item.thermostatBrand" class="mr-2 sac__font-12 med n70">
          {{ capitalize(item.thermostatBrand) }}
        </p>
        <p v-else class="mr-2 sac__font-12 med n70">
          Unspecified
        </p>
        <p
          v-if="thermostat && thermostat.connectionStatus"
          class="mr-2 sac__font-12 med n70"
        >
          •
        </p>
        <div v-if="thermostat">
          <p
            v-if="thermostat.connectionStatus === 'ONLINE'"
            class="sac__font-12 med basil"
          >
            {{ capitalize(thermostat.connectionStatus) }}
          </p>
          <p
            v-if="thermostat.connectionStatus === 'OFFLINE'"
            class="sac__font-12 med tomato"
          >
            {{ capitalize(thermostat.connectionStatus) }}
          </p>
        </div>
      </div>
    </div>
    <div v-if="thermostat" class="flex-row">
      <div class="thermostat-module">
        <div
          v-if="thermostat.connectionStatus == 'ONLINE' && thermostat.humidity"
          class="flex-row mb-1"
        >
          <img
            src="@shared/assets/img/thermostat/drop.png"
            class="mode-ico-small"
            alt="Humidity"
          />
          <p class="sac__font-12 ml-2">
            {{ thermostat.humidity }}%
          </p>
        </div>
        <h5
          v-if="thermostat.connectionStatus == 'ONLINE'"
          class="sac__font-30 bold"
        >
          {{ cToFConverter(thermostat.temperature) }}º
        </h5>
        <p
          v-if="thermostat.connectionStatus === 'OFFLINE'"
          class="sac__font-12 setpoint mt-1 ml-1"
        >
          We are unable to connect to yourthermostat at at this time
        </p>
        <div
          v-else-if="thermostat.mode !== 'OFF'"
          class="flex-row align-center"
        >
          <p
            v-if="thermostat.mode == 'ECO' || thermostat.mode == 'HEATCOOL'"
            class="sac__font-12 setpoint mt-1 ml-1"
          >
            Lo:{{ cToFConverter(thermostat.setpoint.heating) }}º Hi:{{
              cToFConverter(thermostat.setpoint.cooling)
            }}º
          </p>
          <p
            v-if="thermostat.mode == 'COOL'"
            class="sac__font-12 setpoint mt-1 ml-1"
          >
            {{
              thermostat.mode.toLocaleLowerCase().charAt(0).toUpperCase()
                + thermostat.mode.toLocaleLowerCase().slice(1)
            }}
            to
          </p>
          <p
            v-if="thermostat.mode == 'COOL'"
            class="sac__font-12 setpoint mt-1 ml-1 med"
            style="color: #4980ff"
          >
            {{ cToFConverter(thermostat.setpoint.cooling) }}º
          </p>
          <p
            v-if="thermostat.mode == 'HEAT'"
            class="sac__font-12 setpoint mt-1 ml-1"
          >
            {{
              thermostat.mode.toLocaleLowerCase().charAt(0).toUpperCase()
                + thermostat.mode.toLocaleLowerCase().slice(1)
            }}
            to
          </p>
          <p
            v-if="thermostat.mode == 'HEAT'"
            class="sac__font-12 setpoint mt-1 ml-1 med"
            style="color: #eb0a0e"
          >
            {{ cToFConverter(thermostat.setpoint.heating) }}º
          </p>
        </div>
        <div v-if="thermostat.connectionStatus == 'ONLINE'">
          <p
            v-if="thermostat.mode == 'ECO' || thermostat.mode == 'HEATCOOL'"
            class="sac__font-12"
          >
            {{
              thermostat.hvacMode.toLocaleLowerCase().charAt(0).toUpperCase()
                + thermostat.hvacMode.toLocaleLowerCase().slice(1)
            }}
          </p>
          <p v-else class="sac__font-12 text-secondary mb-1">
            {{
              thermostat.hvacMode.toLocaleLowerCase().charAt(0).toUpperCase()
                + thermostat.hvacMode.toLocaleLowerCase().slice(1)
            }}
          </p>
          <img
            v-if="thermostat.mode == 'COOL'"
            src="@shared/assets/img/thermostat/cool.png"
            class="mode-ico-small"
            alt="Cool"
          />
          <img
            v-if="thermostat.mode == 'HEATCOOL'"
            src="@shared/assets/img/thermostat/coolheat.png"
            class="mode-ico"
            alt="HeatCool"
          />
          <img
            v-if="thermostat.mode == 'HEAT'"
            src="@shared/assets/img/thermostat/heat.png"
            class="mode-ico-small"
            alt="Heat"
          />
          <img
            v-if="thermostat.mode == 'ECO'"
            src="@shared/assets/img/thermostat/eco.png"
            class="mode-ico"
            alt="Eco"
          />
        </div>
      </div>
      <div class="thermostat-info pl-15 pr-5" style="width: 100%">
        <div class="flex-row just-between">
          <p class="flex-row">
            Mode
            <SACTooltipItem
              v-if="thermostat.mode === 'ECO'"
              small
              dark
              label=""
              tip="Temperature adjustments are disabled while in Eco Mode"
            />
          </p>
          <p>
            {{ thermostat.mode }}
          </p>
        </div>
        <div class="flex-row just-between">
          <p>HVAC Mode</p>
          <p>{{ thermostat.hvacMode }}</p>
        </div>
        <div class="flex-row just-between">
          <p>Setpoint</p>
          <p v-if="thermostat.mode == 'ECO' || thermostat.mode == 'HEATCOOL'">
            Lo:{{ cToFConverter(thermostat.setpoint.heating) }}º Hi:{{
              cToFConverter(thermostat.setpoint.cooling)
            }}º
          </p>
          <p v-if="thermostat.mode == 'COOL'">
            {{ cToFConverter(thermostat.setpoint.cooling) }}º
          </p>
          <p v-if="thermostat.mode == 'HEAT'">
            {{ cToFConverter(thermostat.setpoint.heating) }}º
          </p>
          <p v-if="thermostat.mode == 'OFF'">
            --
          </p>
        </div>
        <div v-if="thermostat.humidity" class="flex-row just-between">
          <p>Humidity</p>
          <p>{{ thermostat.humidity }}%</p>
        </div>
        <div class="flex-row just-between">
          <p>Ambient temperature</p>
          <p>{{ cToFConverter(thermostat.temperature) }}º</p>
        </div>
      </div>
    </div>
    <p v-else-if="item.thermostatBrand" class="text-center">
      Integration is currently not supported.
    </p>
    <p v-else class="text-center">
      Thermostat type is unspecified.
    </p>
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';
import SACTooltipItem from '@shared/components/sac/SACTooltip.vue';

export default {
  name: 'SmartThermostatCard',
  components: { SACTooltipItem },
  mixins: [customerDetailMixin],
  props: {
    item: Object,
  },
  data() {
    return {
      sensorLocation: '',
      serialNumber: '',
    };
  },
  computed: {
    thermostat() {
      return this.smartThermostatList.find(
        (x) => x.deviceID === this.item.thermostatId,
      );
    },
  },
  mounted() {
    if (this.customer && this.customer.id) {
      // this.$store.dispatch('getCustomerThermostats');
    }
  },
  methods: {
    cToFConverter(temp, unit = 'imperial') {
      const sc = this.thermostat?.temperatureScale;
      let value = 0;
      if (temp && sc.toUpperCase() === 'CELSIUS') {
        value = Number(temp);
        if (unit === 'imperial') {
          value = (9 / 5) * temp + 32;
        }
      } else {
        value = temp;
      }
      return Math.round(value) || '--';
    },
    capitalize(label) {
      return (
        label.toLocaleLowerCase().charAt(0).toUpperCase()
        + label.toLocaleLowerCase().slice(1)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.thermostat-module {
  background-color: #f0f5fa;
  box-shadow: 0px 3px 6px rgba(9, 15, 32, 0.07);

  padding: 0px 40px;
  border-radius: 24px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  display: flex;
  text-align: center;
  width: 210px;

  p {
    color: #7f8290;
    margin-bottom: 3px;
    padding-bottom: 0;

    & .setpoint {
      color: $N95;
      margin-bottom: 3px;
      padding-bottom: 0;
    }
  }
}

.border-bottom {
  border-bottom: 2px solid $N20;
  margin-bottom: 15px;
  padding-bottom: 10px;
}

.mode-ico {
  height: 24px;
  width: 24px;
  margin-right: 3px;
}

.mode-ico-small {
  height: 19px;
  width: 19px;
  margin-right: 3px;
}

.connection-card {
  background-color: #f6f6f7;
  border-radius: 4px;
  padding-top: 3px;
  padding-bottom: 3px;

  p {
    margin-bottom: 0;
  }
}
</style>
